import type { JSX } from 'react';
import { Text } from '../Text';
import { Box } from '../Box';
import type { ColorPickerOption } from './types';

type ColorNameOrHexCodeProps = Pick<ColorPickerOption, 'name'> & {
  hexCode: ColorPickerOption['value'];
};

export const ColorNameOrHexCode = ({ name, hexCode }: ColorNameOrHexCodeProps): JSX.Element => {
  return (
    <Box
      alignItems="center"
      gap="space-04"
      grow={1}
      justifyContent="space-between"
    >
      <Text
        renderAs="span"
        variant={name != null ? 'body3' : 'body3Mono'}
      >
        {name ?? hexCode}
      </Text>
      {name != null && (
        <Text
          prominence="secondary"
          renderAs="span"
          variant="body4Mono"
        >
          {hexCode}
        </Text>
      )}
    </Box>
  );
};
